import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';

// Elements
import LatestNewsSection from "../elements/latest-news-slider";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";

class Faq extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>PREGUNTAS</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> INICIO</Link></li>
											<li className="breadcrumb-item active" aria-current="page">PREGUNTAS</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-sp3">
						<div className="container">
							<div className="row">
								<div className="col-lg-6">
									<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
										<Accordion.Item eventKey="0">
											<Accordion.Header>¿Qué es una SOFIPO y quién la regula?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Es una Sociedad Financiera Popular regulada por la CNBV y supervisada por la CONDUSEF, autorizada para captar ahorro y otorgar créditos.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header>¿Mi dinero está protegido?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Sí, todas las SOFIPO cuentan con el fondo de protección Prosofipo, que cubre tus ahorros hasta por 25,000 UDIS (aprox. $200,000 MXN).</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="2">
											<Accordion.Header>¿Cuál es la diferencia entre una SOFIPO y un Banco?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Aunque ambas captan ahorro, las SOFIPO se enfocan en la inclusión financiera y suelen ofrecer tasas de rendimiento más altas que la banca tradicional.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="3">
											<Accordion.Header>¿Cuál es el monto mínimo para comenzar a invertir?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Puedes abrir tu cuenta y comenzar a generar rendimientos desde montos muy accesibles (por ejemplo, desde $100 MXN).</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="4">
											<Accordion.Header>¿Qué tasas de interés ofrecen?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Nuestras tasas son competitivas y fijas; el porcentaje anual depende del plazo que elijas para dejar crecer tu dinero</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="5">
											<Accordion.Header>¿Mis inversiones pagan impuestos?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Las inversiones en SOFIPO están exentas de ISR siempre que el saldo promedio anual no exceda las 5 UMAs anuales (aprox. $198,000 MXN).</p>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
								<div className="col-lg-6">
									<Accordion defaultActiveKey="2" className="accordion ttr-accordion1">
										<Accordion.Item eventKey="0">
											<Accordion.Header>¿Cómo puedo solicitar un crédito?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">El proceso es sencillo y digital: solo necesitas tu identificación oficial, comprobante de domicilio y completar nuestra solicitud en línea.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header>¿Qué tipo de créditos otorgan?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Ofrecemos desde créditos personales para cubrir imprevistos hasta créditos productivos para impulsar tu negocio o emprendimiento.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="2">
											<Accordion.Header>¿Cómo puedo retirar mi dinero?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Si tu dinero está en "Ahorro a la vista", puedes disponer de él 24/7 mediante transferencia SPEI. Si es "Inversión a plazo", estará disponible al finalizar dicho periodo.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="3">
											<Accordion.Header>¿Qué requisitos necesito para abrir una cuenta?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Ser mayor de edad, residir en México, contar con una identificación vigente (INE/Pasaporte) y un número de celular activo.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="4">
											<Accordion.Header>¿Cómo abro mi cuenta?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Para más información envía un correo a xxxxxx@altheca.com</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="5">
											<Accordion.Header>Telefonos de contacto:</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">6181006874 / 6181000000</p>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
							</div>
						</div>
					</section>
					
					<LatestNewsSection />
					
				</div>
			
			</>
		);
	}
}

export default Faq;